<template>
    <div class="table-user">
        <btn-back :pushTo="{name: $route.params.parent === 'plans' ? 'ReplenishmentPlans' : 'ReplenishmentShipments'}" />
        <div class="d-flex mt-2 mb-3 align-items-center">
            <h6 class="mb-0"><b>Shipping ID: {{$route.query.planNumber ? $route.query.planNumber : $route.params.planId}}</b></h6>
            <b-btn class="ml-auto"
                   variant="primary-user"
                   size="sm"
                   v-if="$route.params.parent === 'plans'"
                   @click="goToAddProductsPage">
                Add products
            </b-btn>
        </div>
        <div class="scroll-x">
            <table-element
                :items="products"
                :fields="getFields"
                :row-class="rowClass"
                @sort="event => sortTable(event)">
                <div slot="product.name" slot-scope="data">
                    <div v-if="data.item.product.status === 'suspended'" class="d-flex align-items-center">
                        <b-btn variant="link"
                               :to="{name: 'SingleProduct', params: {id: data.item.product.id}}"
                               v-b-popover.hover="'This product has blank required fields. Please provide required information to proceed the work or remove this product from the list.'"
                               class="text-danger product-popover">&#9888;
                        </b-btn>
                        <span>{{data.value}}</span>
                    </div>
                    <template v-else>
                        {{data.value}}
                    </template>
                </div>
                <div class="d-flex"
                     slot="action"
                     slot-scope="data">
                    <b-btn variant="primary-user"
                           size="sm"
                           class="mr-3"
                           :to="{name: 'SingleProduct', params: {id: data.item.product.id}}">Edit
                    </b-btn>
                    <b-btn variant="danger"
                           size="sm"
                           :disabled="products.length <= 1"
                           @click="removeFromShippingPlan(data.item.id, data.item.product.id)">Remove
                    </b-btn>
                </div>
                <quantity-column slot="quantitySent"
                    slot-scope="data"
                    :edit="planMod"
                    :item="data.item"
                    @input="changeQuntityOfProduct" />

            </table-element>
        </div>
        <div class="mb-3 mt-3 mr-auto table-user-footer">
            <div class="d-flex">
                <template v-if="$route.params.parent === 'shipments'">
                    <b-btn class="mr-3"
                           variant="primary-user"
                           size="sm"
                           disabled>
                        Cancel
                    </b-btn>
                    <b-btn variant="primary-user"
                           size="sm"
                           disabled>
                        Return to plans
                    </b-btn>
                </template>
                <template v-if="$route.params.parent === 'plans'">
                    <b-btn type="button"
                           variant="primary-user"
                           size="sm"
                           @click="deletePlan">
                        Delete shipping plan
                    </b-btn>
<!--                    <b-btn class="ml-2 mr-2"-->
<!--                           variant="primary-user"-->
<!--                           size="sm"-->
<!--                           disabled>-->
<!--                        Copy shipping plan-->
<!--                    </b-btn>-->
                    <b-btn class="ml-auto mr-0 ml-auto"
                           variant="primary-user"
                           size="sm"
                           :disabled="disabledNext || sending"
                           @click="saveProductOfReplenishment">
                        Continue
                    </b-btn>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import {tableMixins} from '@/mixins/tableMixins'

    import TableElement from '~cp/UserPanel/Elements/TableElement'
    import TablePagination from '~cp/UserPanel/Elements/TablePagination'
    import QuantityColumn from './QuantityColumn'

    import replenishmentItem from '@/assets/js/columns/replenishmentItem'
    import replenishmentPlanItem from '@/assets/js/columns/replenishmentPlanItem'

    let parent = ''

    export default {
        name: 'ReplenishmentItem',
        mixins: [tableMixins],
        components: {
            TableElement,
            QuantityColumn,
            TablePagination
        },
        beforeCreate() {
            parent = this.$route.params.parent
        },
        data() {
            return {
                endpoint: this.$endpoints.incomesItems(this.$route.params.planId),
                sending: false
            }
        },
        computed: {
            getFields() {
                if (parent === 'plans') {
                    return [...replenishmentItem, ...replenishmentPlanItem]
                } else return replenishmentItem
            },
            planMod() {
                return parent === 'plans'
            },
            disabledNext() {
                if (this.products.length > 0) {
                    return this.products.some(item => item.product.status === 'suspended' || item.quantitySent === 0 || item.quantitySent === '' || item.quantitySent > item.product.stock.available)
                }
                return true
            },
            products() {
                return this.$store.state.replenishment.planWorkingStatus ? this.$store.state.replenishment.productListOfCurrentPlan : this.items
            }
        },
        beforeRouteLeave: function(to, from, next) {
            if (to.name !== 'ReplenishmentAddProducts' && this.$store.state.replenishment.planWorkingStatus) {
                this.$store.commit('RESET_PRODUCT_LIST')
                next()
            } else {
                next()
            }
        },
        methods: {
            rowClass(item) {
                if (!item) return
                if (item.product.status === 'suspended' || item.quantitySent === 0 || item.quantitySent === '' || item.quantitySent > item.product.stock.available) {
                    return 'table-danger'
                }
            },
            removeFromShippingPlan(productIdOfPlan, productId) {
                let productIndex = this.products.findIndex(product => {
                    return productIdOfPlan ? product.id === productIdOfPlan : product.product.id === productId
                })
                let payload = {
                    planId: this.$route.params.planId,
                    productId: productId
                }
                if (productIndex !== -1) {
                    if (productIdOfPlan && !!this.products[productIndex].id) {
                        this.$store.dispatch('deleteFromShippingPlan', payload)
                            .then(() => {
                                this.products.splice(productIndex, 1)
                            })
                    } else {
                        this.products.splice(productIndex, 1)
                    }
                }
            },
            deletePlan() {
                this.$store.dispatch('deleteReplenishment', this.$route.params.planId).then(() => this.$router.go(-1))
            },
            changeQuntityOfProduct({ productId, quantity }) {
                let productIndex = this.products.findIndex(product => product.product.id === productId)
                if (productIndex > -1) {
                    this.$set(this.products, productIndex, {
                        ...this.products[productIndex],
                        quantitySent: quantity
                    })
                }
            },
            saveProductOfReplenishment() {
                this.sending = true
                let productsListData = this.products.map(product => {
                    return {
                        productId: product.product.id,
                        quantity: +product.quantitySent
                    }
                })
                this.$api('PATCH', this.$endpoints.incomesItems(this.$route.params.planId), {products: productsListData})
                    .then((response) => {
                        this.$store.dispatch('globalAlertAction', {
                            type: 'info',
                            title: `Shipping plan updated`
                        })
                        this.$router.push({name: 'Step1', params: {planId: this.$route.params.planId}})
                    }).finally(() => {
                        this.sending = false
                    })
            },
            goToAddProductsPage() {
                this.$store.commit('SET_PRODUCT_LIST', this.products)
                this.$router.push({
                    name: 'ReplenishmentAddProducts',
                    params: {planId: this.$route.params.planId, parentBred: {route: this.$route}},
                    query: {
                        planNumber: this.$route.query.planNumber
                    }
                })
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Replenishment/ReplenishmentItem.vue